import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import { ConfirmDialog } from "../UI";

const DeleteCompany = ({ companyCode, callback }) => {
  const [visible, setVisible] = useState(false);
  const deleteCompany = () => {
    setVisible(false);
    if (typeof callback === "function") {
      callback();
    }
  };
  return (
    <>
      <IconButton onClick={() => setVisible(true)} aria-label="delete company">
        <DeleteOutline />
      </IconButton>
      <ConfirmDialog
        open={visible}
        title={`Delete Company ${companyCode}`}
        confirmText="Delete"
        destructive
        cancelAction={() => setVisible(false)}
        confirmAction={deleteCompany}
      >
        Are you sure you want to delete the company {companyCode}? Doing so
        will remove all users assigned to that company and all of their data.
        This action is not reversible.
      </ConfirmDialog>
    </>
  );
};

export default DeleteCompany;
